export const initState = {
  lang: null,
};

const handlers = {
  // eslint-disable-next-line
  ["SET_VALUE"]: (state, payloads) => {
    return {
      ...state,
      [payloads.key]: payloads.value,
    };
  },
};

export const reducer = (state, { type, ...payloads }) => {
  const handler = handlers[type];
  if (handler) {
    return handler(state, payloads);
  }
  return state;
};
